<!--
 * @Author: Tina Huang
 * @Date: 2024-01-08 10:12:15
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-30 09:19:31
 * @Description: 
-->
<template>
  <div class="lib-container">
    <br />
    <h1>
      <el-tag type="warning" v-show="isVip">永久会员</el-tag
      >&nbsp;&nbsp;模板领取
    </h1>
    <p :class="['tip', tipAm ? 'am' : '']">
      由于近期模板二次分享和盗售的情况频发，所以后续模板不再支持直接获取，需要模板的请从下方获取～
      <br /><strong>小红书（肥汪卷）</strong> |
      <strong>B站（阿汪同学）</strong>
    </p>
    <template v-if="isShowCard">
      <el-card
        class="box-card"
        v-loading="loading"
        element-loading-text="模板加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-button
          type="primary"
          class="code-box"
          round
          @click="handleLinkCopy(item)"
          >领取模板</el-button
        >
        <br /><br />
        <img :src="item && item.cover" />
        <!-- <template-frame-vue :link="item && item.rlink" /> -->
      </el-card>
    </template>
    <template v-else>
      <el-input
        class="code-box"
        v-model="code"
        placeholder="请输入获取模板口令"
      ></el-input>
      <br /><br />
      <el-button
        type="primary"
        class="code-box"
        round
        :loading="loading"
        @click="onGetTemp"
        >领取模板</el-button
      >
    </template>
    <br />
    <el-button
      type="text"
      class="text-btn"
      @click="() => ((isShowTip = true), (tipAm = true))"
      >如何获取模板口令？</el-button
    >
  </div>
</template>
<script>
import TemplateFrameVue from "./mobile/templateFrame.vue";
export default {
  // components: { TemplateFrameVue },
  data() {
    return {
      code: this.$route.params.code,
      type: this.$route.params.type,
      loading: false,
      isShowCard: true,
      item: null,
      isShowTip: false,
      realCode: "",
      tipAm: false,
      params: null,
      domain: "https://httishere666.notion.site/",
    };
  },
  mounted() {
    if (!this.code) {
      this.isShowCard = false;
    } else if (this.type === "code") {
      this.isShowTip = true;
      this.getTemplate({ code: this.code }, this.type);
    } else this.formatCode();
  },
  computed: {
    isVip() {
      try {
        const str = window.atob(this.code);
        const str_a = str.split("-");
        return str_a[str_a.length - 1] === "vip";
      } catch {
        return false;
      }
    },
  },
  methods: {
    openNewWin(link) {
      window.open(
        link,
        "单独窗口",
        "height=300,width=600,top=300,left=200,toolbar=no,menubar=no, scrollbars=no,resizable=no,location=no, status=no"
      );
    },
    // link-code-time-vip?
    formatCode() {
      try {
        const str = window.atob(this.code).split("-");
        this.params = {
          link_id: window.atob(str[0]),
          code: str[1],
          time: str[2],
        };
        this.getTemplate(this.params, this.type);
      } catch {
        this.$message.error("模板不存在！");
        this.isShowTip = true;
        this.isShowCard = true;
      }
    },
    onGetTemp() {
      this.getTemplate({ code: this.code }, this.type);
    },
    getTemplate(params, type) {
      const _this = this,
        { code, link_id, time } = params;
      if (!code) return;
      if (type === "link" && (!code || !link_id)) return;
      _this.loading = true;
      this.$axios.get(`./picks.json?v=${Math.random()}`).then((res) => {
        _this.loading = false;
        let times = res.data;
        let item = null;
        if (type === "link") {
          item = times.find(
            (item) => item.code === code || item.link.includes(link_id)
          );
        } else {
          item = times.find((item) => item.code === code);
        }
        if (!item)
          return _this.$message.error("模板不存在！请确认模板获取口令");
        _this.item = item;
        _this.isShowCard = true;
      });
    },
    handleLinkCopy(item) {
      if (!item) return this.$message.error("模板不存在！");
      this.openNewWin(item.rlink);
      // window.open(item.rlink, "__blank");
    },
  },
};
</script>
<style lang="less" scoped>
.lib-container {
  text-align: center;
  padding-top: 5vw;
  max-height: 60vh;
  min-height: unset;
  h1 {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    width: 100%;
    max-width: 400px;
    min-width: 300px;
  }
  .code-box {
    max-width: 400px;
    min-width: 300px;
    width: 100%;
  }
}
.box-card {
  min-height: 20vh;
  max-width: 400px;
  margin: 0 auto;
}
.tip {
  margin: 20px auto;
  text-align: left;
  line-height: 2;
  max-width: 400px;
  font-size: 14px;
  strong {
    color: rgb(174, 87, 124);
    display: inline-block;
    background: rgba(132, 143, 224, 0.1);
    border-radius: 5px;
    padding: 0 2px;
  }
  &.am {
    color: rgb(174, 87, 124);
  }
}
.text-btn {
  font-size: 12px;
}
</style>